import { Card, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const NoActiveRfxs = () => {
  const { t } = useTranslation('dashboard')

  return (
    <Card sx={{ width: '100%', py: 15 }}>
      <Stack gap={5} alignItems="center">
        <Typography variant="body-medium" color="text.muted">
          {t('rfx-section.table.no-active-rfxs')}
        </Typography>
      </Stack>
    </Card>
  )
}
